import React, { useState } from "react";
import startCase from "lodash/startCase";
import classnames from "classnames";
import { ENTITY_COLOR_UID_MAP } from "components/FormerEditor/common/constants/entity";
import { getIconForUID } from "components/FormerEditor/utils";
import { COLORS } from "utils/styles";
import { useHoverProps } from "utils/hooks";

const DEFAULT_CLASSES = {
  container: "pt3 ph3 pb3 flex flex-row bb hairline-1 pb3 bh--inset",
  icon:
    "flex items-center justify-center bg-content--secondary br2 icon--boundary flex-shrink-0",
  label: "fw5 f5",
  description: "f6 pt2 lh-copy"
};

const OptionListOption = ({
  label,
  icon,
  uid,
  hideIcon,
  description,
  isSelected,
  onClick,
  disabled,
  isLast,
  isFirst,
  hasMultiple,
  customClasses
}) => {
  const classes = {
    ...DEFAULT_CLASSES,
    ...customClasses
  };
  const [hover, setHover] = useState(false);
  const Icon = !hideIcon && getIconForUID(icon || uid);
  const CheckmarkIcon = getIconForUID("checkmark");
  const hoverProps = useHoverProps({ hover, setHover });
  const isMiddle = !isFirst && !isLast && hasMultiple;
  const containerProps = {
    className: classnames(classes.container, {
      "cursor-not-allowed": disabled,
      "pointer": !disabled,
      "bg-content--secondary": hover && !disabled,
      "bg-transparent": !hover,
      "bl br bt hairline-1": isMiddle,
      "br-6 ba hairline-1": !hasMultiple,
      "brtr-6 brtl-6 bt bl br hairline-1": isFirst,
      "brbr-6 brbl-6 bt bb bl br hairline-1": isLast
    }),
    ...hoverProps
  };
  if (!disabled) {
    containerProps.onClick = onClick;
  }

  const color = ENTITY_COLOR_UID_MAP[uid] || COLORS.primary;
  let descriptionContent;
  if (description) {
    if (Array.isArray(description)) {
      descriptionContent = (
        <ul className={`list ma0 pa0 ${classes.description}`}>
          {description.map((descriptionEl, descrIx) => (
            <div key={descrIx}>{descriptionEl}</div>
          ))}
        </ul>
      );
    } else {
      descriptionContent = (
        <div className={classes.description}>{description}</div>
      );
    }
  }

  return (
    <li {...containerProps}>
      <div className="ph3 flex flex-row w-100">
        {Icon && (
          <div style={{ height: 28, width: 28 }} className={classes.icon}>
            <Icon size={16} color="#ffffff" />
            <style jsx>{`
              .icon--boundary {
                background-color: ${color};
              }
            `}</style>
          </div>
        )}
        <div className="flex flex-column w-100">
          <div
            className={classnames("flex flex-column h-100", {
              "pl3": Icon,
              "o-40": !isSelected,
              "justify-center": !description
            })}
          >
            <div
              className={classnames("flex flex-row justify-between", {
                "items-center": !description
              })}
            >
              <div className={classes.label}>{startCase(label)}</div>
              <CheckmarkIcon
                size={20}
                color={isSelected ? COLORS.blue : COLORS.deselected}
              />
            </div>
            {descriptionContent}
          </div>
        </div>
      </div>
    </li>
  );
};

export default OptionListOption;
